"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Container = _interopRequireDefault(require("../Container"));
var _SurchargeAnnotation = _interopRequireDefault(require("../SurchargeAnnotation"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var styles = {
  container: {
    paddingBottom: "10px",
    borderRadius: "0 0 ".concat(_userflow["default"].shape.borderRadiusBig, " ").concat(_userflow["default"].shape.borderRadiusBig)
  },
  image: {
    width: '100%'
  }
};
var Graph = function Graph(_ref) {
  var link = _ref.link,
    surcharge = _ref.surcharge;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container,
    bgColor: "#fff",
    className: "Graph"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "\u0413\u0440\u0430\u0444\u0438\u043A \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0446\u0435\u043D",
    src: link,
    style: styles.image
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 5
  }), /*#__PURE__*/_react["default"].createElement(_SurchargeAnnotation["default"], null, surcharge === 'present' ? 'Цены включают доплаты от туроператора' : 'Цены могут не включать доплаты от туроператора'));
};
Graph.propTypes = {
  link: _propTypes["default"].string.isRequired,
  surcharge: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = Graph;